import { createAction } from '@reduxjs/toolkit';
import {
  SignalingUserLeftPayload,
  User,
  UserHandLoweredPayload,
  UserHandRaisedPayload,
  UserId,
  UserLeftBatchPayload,
} from 'features/users/types';
import { type EventUser, type SignalingEventPayload } from 'services/signaling';
import { BanDetails } from 'features/application/types';
import { InvitationEmailUser } from 'features/users/modals/invite-user/types';

export const signalingUserJoined = createAction<User>('signaling/users/userJoined');
export const signalingUserLeft = createAction<SignalingUserLeftPayload>('signaling/users/userLeft');
export const signalingUserLeftBatch = createAction<UserLeftBatchPayload>(
  'signaling/users/userLeftBatch'
);

export const signalingHandRaised = createAction<UserHandRaisedPayload>(
  'signaling/users/handRaised'
);
export const signalingHandLowered = createAction<UserHandLoweredPayload>(
  'signaling/users/handLowered'
);

export const kickUser = createAction<{ userId: UserId; breakoutId?: string }>('users/kick');
export const kickUsers = createAction<string>('users/kickUsers');
export const signalingUserKicked = createAction<{
  reason: 'kicked_by_user' | 'session_duplicated';
  initiator: EventUser;
}>('signaling/users/kicked');

export const banUser = createAction<{
  id: UserId;
  permanent: boolean;
  duration?: number;
}>('users/ban');
export const signalingUserBanned = createAction<BanDetails>('signaling/users/banned');

// room entry control
export const admitEntry = createAction<{ userId: UserId; roomId?: string }>('users/admitEntry');
export const rejectEntry = createAction<UserId>('users/rejectEntry');
export const bulkRejectEntry = createAction('users/bulkRejectEntry');
export const bulkAdmitEntry = createAction('users/bulkAdmitEntry');

export const signalingWaitingUserJoined = createAction<User>('signaling/users/waitingUserJoined');
export const signalingWaitingUserLeft = createAction<SignalingUserLeftPayload>(
  'signaling/users/waitingUserLeft'
);
export const signalingWaitingUserLeftBatch = createAction<UserLeftBatchPayload>(
  'signaling/users/waitingUserLeftBatch'
);
export const signalingWaitingUsersUpdated = createAction<User[]>(
  'signaling/users/waitingUsersUpdated'
);
export const clearWaitingUsersList = createAction('users/clearWaitingUsersList');
export const signalingAccessRejected = createAction('signaling/users/accessRejected');
export const signalingBulkAccessRejected = createAction('signaling/users/bulkAccessRejected');

export const kickUserRequested = createAction<UserId>('users/kickRequested');
export const kickUsersRequested = createAction<UserId>('users/kickUsersRequested');

export const renameUserRequested = createAction<{
  id: UserId;
  name: string;
  local?: boolean;
}>('users/renameUserRequested');
export const signalingUserRenamed = createAction<
  SignalingEventPayload<{
    id: UserId;
    name: string;
  }>
>('signaling/users/userRenamed');

export const userRenamed = createAction<{ id: UserId; name: string }>('users/userRenamed');

export const sendInvitationEmailsRequested = createAction<InvitationEmailUser[]>(
  'users/sendInvitationEmailsRequested'
);

export const signalingAvatarChanged = createAction<
  SignalingEventPayload<{
    url: string;
  }>
>('signaling/users/avatarChanged');

export const signalingAvatarDeleted = createAction<{
  userId: UserId;
}>('signaling/users/avatarDeleted');

export const avatarDeleteRequested = createAction('users/avatarDeleteRequested');

export const avatarUploadSucceeded = createAction<{ url: string }>('users/avatarUploadSucceeded');
